
import React, { useState } from "react";
import PopupAvis from "../../components/PopupAvis";
import { transformer } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  respondToReview,
  selectRespondStatus,
  selectRespondError,
} from "../../store/slices/avisSlice";
import { toast } from "react-toastify";


function ReponseComment({ isPopupVisible, setPopupVisible, review }) {
  const [reponse, setReponse] = useState("");
  const dispatch = useDispatch();
  const respondStatus = useSelector(selectRespondStatus);
  const respondError = useSelector(selectRespondError);
  // console.log("review:",review)

  return (
    <PopupAvis
      isOpen={isPopupVisible}
      onClose={() => setPopupVisible(false)}
      onAction={async () => {
        // console.log("Clicked publier");
        if (reponse.trim() && review?.id) {
          // console.log("Dispatching...");
          await dispatch(
            respondToReview({ reviewId: review.id, responseText: reponse })
          );
           toast.success("Réponse envoyé avec succèes ");
          setPopupVisible(false);
        } else {
          // console.warn("Submission error");
          toast.error("Erreur : " ,"Une erreur est survenue.");
        }
      }}
      title="Répondre à l’avis"
      className="width-popup-comment"
      text={
        <div>
          <p className="text-sm text-gray-500">
            Les avis sont publics et pourront être lus par les utilisateurs
            Twyny.
          </p>

          <div className="mt-3 rounded d-flex justify-content-between">
            <div>
              <h5>{review?.client}</h5>
              <span className="body text-gray-600 bg-gray-100">
                {review?.prestation}
                <img
                  className="separator"
                  src="/images/separateur.svg"
                  alt="separateur"
                />{" "}
                {transformer(review?.dateReservation)} -{" "}
                {new Date(review?.heureReservation).toLocaleTimeString(
                  "fr-FR",
                  {
                  //  timeZone: "Europe/Paris",
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )}
              </span>
            </div>
          </div>

          <p className="mt-2 frame-comment gray-Bg">{review?.comment}</p>

          <div className="mt-4">
            <div className="mb-8">
              <label htmlFor="reponse" className="legend">
                Réponse à l’avis
              </label>
            </div>
            <div className="textarea-container">
              <textarea
                id="reponse"
                className="form-control fildtextarea"
                rows={7}
                maxLength={1000}
                placeholder="Rédigez votre réponse…"
                value={reponse}
                onChange={(e) => setReponse(e.target.value)}
              />
            </div>
            <span className="counter-review">{reponse?.length}/1000</span>

            {respondStatus === "failed" && (
              <p className="text-danger mt-2">
                {respondError?.message || "Erreur inconnue"}
              </p>
            )}
          </div>
        </div>
      }
      actionButtonText={
        respondStatus === "loading" ? "Envoi en cours..." : "Publier ma réponse"
      }
      closeButtonClassName="hidden"
      actionButtonClassName="bg-blue-600 text-white px-4 py-2 rounded mt-4"
    />
  );
}

export default ReponseComment;
